import React from 'react';
import { ReactComponent as Logo } from '@nintex-ux/icons-svg/icons/logos/nintex-logo.svg';
import './Layout.scss';

function Layout({ children }) {
  return (
    <div className="app">
      <header className="header">
        <Logo />
      </header>
      <main className="main">
        <h2 className="title">Nintex Scheduler Dashboard</h2>
        {children}
      </main>
    </div>
  );
}

export default Layout;
